import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=511a96fe&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=511a96fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a96fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511a96fe')) {
      api.createRecord('511a96fe', component.options)
    } else {
      api.reload('511a96fe', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=511a96fe&scoped=true&", function () {
      api.rerender('511a96fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GkDry5jXXL5o/JS/teamMember.vue"
export default component.exports